import React, { useState } from "react";
import { toast } from "sonner";
import { emailSubscription } from "../../api/customer.api";

export default function NewsletterForm({ label, btnText, btnArrowUrl }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await emailSubscription(email);

      if (response.message.toLowerCase() === "success") {
        toast.success("Subscribed successfully");
        setEmail("");
      }
    } catch (error) {
      toast.error("Something went wrong");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {label && <p>Your Email</p>}
      <form className="cs_newsletter_form">
        <input
          type="text"
          className="cs_form_field"
          placeholder="example@email.com"
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className="cs_btn cs_style_1" type="submit" onClick={handleSubmit}>
          <span>{loading ? "Subscribing..." : btnText}</span>
          {!loading && (
            <i>
              <img src={btnArrowUrl} alt="Icon" />
              <img src={btnArrowUrl} alt="Icon" />
            </i>
          )}
        </button>
      </form>
    </>
  );
}
